// removed by extract-text-webpack-plugin
module.exports = {"light-grey":"#d4d4d4","ipad-portrait":"768px","actionMenu":"d8C3Eh-i5OJ0MeoTm_IGz","withSeparator":"_1GiuMhHTTsVGxNkN9Hi1z9","statusPage":"_3nX1atmBNyO2l-XWKx0ccS","landing":"_3p2MmYN9VknbNa8tW_g76P"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Header/ActionMenu/ActionMenu.css
// module id = 1341
// module chunks = 0